import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import IpLogReports from "../../components/Reports/IpLogReports.jsx";
import PurchaseReports from "../../components/Reports/PurchaseReports.jsx";
import SalesSummary from "../../components/Reports/SalesSummary.jsx";
import Tabination from "../../reusableComponents/Tabination";
import "./style.scss";

const Reports = () => {
  const location = useLocation();

  const items = [
    {
      name: "Purchase Report",
      path: "purchase-report",
    },
    {
      name: "IP Log Report",
      path: "ip-log-report", // 👈 your route path
    },
    {
      name: "Sales Summary",
      path: "sales-summary",
    },
  ];

  // figure out which tab is active from URL
  const currentPath = location.pathname.split("/").pop(); // "purchase-report" | "ip-log-report"
  const activeTabIndex =
    items.findIndex((item) => item.path === currentPath) === -1
      ? 0
      : items.findIndex((item) => item.path === currentPath);

  return (
    <>
      <Tabination variant={3} tabItems={items} activeTab={activeTabIndex} />
      <div className="coupons_wrapper">
        <div className="coupons">
          {" "}
          <div className="reports_wrapper">
            <Routes>
              <Route
                path="/"
                element={<Navigate to="purchase-report" replace={true} />}
              />
              <Route path="purchase-report" element={<PurchaseReports />} />
              <Route path="ip-log-report" element={<IpLogReports />} />
              <Route path="sales-summary" element={<SalesSummary />} />
            </Routes>
          </div>
        </div>
      </div>
    </>
  );
};

export default Reports;
